<script lang="ts" module>
	export interface TopBarContainerProps {
		class?: string;
		dark?: boolean | undefined;
		children?: import('svelte').Snippet;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { Container } from '../../../../components/Container';

	let { dark = undefined, children, ...rest }: TopBarContainerProps = $props();

	const dataCyPrefix = 'container';
</script>

<header
	class={twMerge(
		classNames('sticky top-0 z-40 flex h-[3rem] w-full items-center lg:bg-gray-900', {
			'bg-gray-900': dark,
			'bg-gray-0 border-b border-gray-200 lg:border-b-0': !dark
		}),
		rest.class
	)}
>
	<Container dataCy={dataCyPrefix} class="h-full">{@render children?.()}</Container>
</header>
